import type { ReactNode } from "react";

import { CheckCircleIcon, InfoIcon } from "@phosphor-icons/react";

import { Banner, type BannerProps, classNames } from "@alpacahq/ui/old";

export type MaintenanceBannerVariant = "maintenance" | "completed";

const VARIANT: Record<MaintenanceBannerVariant, BannerProps["variant"]> = {
  maintenance: "info",
  completed: "success",
};

const ICONS: Record<MaintenanceBannerVariant, ReactNode> = {
  maintenance: <InfoIcon className="text-light-blue-600" size={20} />,
  completed: <CheckCircleIcon className="text-emerald-600" size={20} />,
};

const CLASS_NAMES: Record<
  MaintenanceBannerVariant,
  { title: string; container: string }
> = {
  maintenance: {
    title: "text-light-blue-600",
    container: "bg-light-blue-50 border border-blue-400",
  },
  completed: {
    title: "text-emerald-600",
    container: "bg-emerald-50 border border-emerald-400",
  },
};

export interface MaintenanceBannerPresentationProps {
  title: string;
  message: string;
  variant: MaintenanceBannerVariant;
  className?: string;
}

export const MaintenanceBannerPresentation = ({
  title,
  message,
  variant,
  className,
}: MaintenanceBannerPresentationProps) => (
  <Banner
    variant={VARIANT[variant]}
    icon={ICONS[variant]}
    title={
      <h3
        className={classNames(
          "m-0 p-0 font-semibold text-base",
          CLASS_NAMES[variant].title,
        )}
      >
        {title}
      </h3>
    }
    message={<p className="m-0 p-0 text-gray-700 text-sm">{message}</p>}
    className={classNames(CLASS_NAMES[variant].container, className)}
  />
);
